import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Navbar.module.css";
import CartIcon from "Utils/Assets/SVGs/CartIcon";
import { CartIconProps } from "@model/NavBar.model";



const Cart: FC<CartIconProps> = ({ count, className }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`${styles.cartButton} ${className ?? ""}`}
      onClick={() => navigate("/cart")}
      aria-label="Open cart"
      data-testid="cart-icon-button"
    >
      <CartIcon width={28} height={28} data-testid="cart-icon" />

      {count > 0 && (
        <span className={styles.count} data-testid="cart-count">
          {count}
        </span>
      )}
    </button>
  );
};

export default Cart;
